<template>
  <div class="statistics-center">
    <table border="1" class="rate-table">
      <tr>
        <th>{{ props.year }}</th>
        <th v-for="(item, index) in PQCkeyList" :key="index" class="">
          {{ item.label }}
        </th>
      </tr>

      <tr>
        <th>交检数量</th>
        <td v-for="(item, index) in SOPRTable.submission" :key="index">
          {{ item }}
        </td>
      </tr>

      <tr>
        <th>合格数</th>
        <td v-for="(item, index) in SOPRTable.qualified" :key="index">
          {{ item }}
        </td>
      </tr>

      <tr>
        <th>一次合格率</th>
        <td v-for="(item, index) in SOPRTable.passRate" :key="index">
          <div v-if="item">{{ item }}%</div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { defineComponent, inject, watch, reactive, computed } from "vue";
import { PQCProductOption } from "@/views/productDaily/serve/option";

export default defineComponent({
  props: {
    statisticsData: Object,
    year: String,
  },
  setup(props, context) {
    //
    const injectPQCkeyList = inject("PQCkeyList", []);

    const PQCkeyList = PQCProductOption.filter(
      (f) =>
        f.label !== "束腰" && f.label !== "绕光纤参考臂" && f.label !== "包装"
    );

    PQCkeyList.push({ label: "合计", value: "total" });

    // 合格率汇总
    const SOPRTable = reactive({
      submission: [],
      qualified: [],
      passRate: [],
    });
    // 重置合格率汇总表格
    const setSOPREmpty = () => {
      SOPRTable.submission.length = 0;
      SOPRTable.qualified.length = 0;
      SOPRTable.passRate.length = 0;
      PQCkeyList.forEach(() => {
        SOPRTable.submission.push(0);
        SOPRTable.qualified.push(0);
        SOPRTable.passRate.push(0);
      });
    };
    const setSOPRData = (data, processIndex) => {
      const totalIndex = PQCkeyList.length - 1;
      // 送检数量
      SOPRTable.submission[processIndex] += data.submissionNum;
      // 合格数量
      SOPRTable.qualified[processIndex] += data.qualifiedNum;

      if (SOPRTable.submission[processIndex] !== 0) {
        // 一次合格率
        SOPRTable.passRate[processIndex] = Number(
          (SOPRTable.qualified[processIndex] /
            SOPRTable.submission[processIndex]) *
            100
        ).toFixed(2);
      }
      // 合计
      SOPRTable.submission[totalIndex] += data.submissionNum;
      SOPRTable.qualified[totalIndex] += data.qualifiedNum;

      if (SOPRTable.qualified[totalIndex] !== 0) {
        SOPRTable.passRate[totalIndex] = Number(
          (SOPRTable.qualified[totalIndex] / SOPRTable.submission[totalIndex]) *
            100
        ).toFixed(2);
      }
    };

    // 更新表格数据
    const updateRateTable = (data, processIndex) => {
      Object.keys(data).forEach((month) => {
        // 月份汇总数据
        const monthData = data[month];
        // 年度汇总数据
        setSOPRData(monthData, processIndex);
      });
    };

    const setRateData = (data) => {
      if (Object.prototype.toString.call(data) !== "[object Object]") return;
      if (Object.keys(data).length === 0) return;
      Object.keys(data).forEach((key) => {
        const processData = data[key];
        const index = PQCkeyList.findIndex((f) => f.value === key);

        if (processData && index !== -1) {
          updateRateTable(processData, index);
        }
      });
    };

    watch(
      () => props.statisticsData,
      (val) => {
        setSOPREmpty();
        setRateData(val);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      PQCkeyList,
      SOPRTable,
    };
  },
});
</script>

<style lang="less" scoped>
.rate-table > tr > th {
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
}

.rate-table > tr > :nth-child(odd) {
  background: #e0e0e0;
}

// .rate-table > tr:nth-child(odd) {
//   background: #e0e0e0;
// }
</style>
